import { defineStore } from 'pinia'

interface AppState {
  isMobile: boolean
  menuVisible: boolean
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    isMobile: false,
    menuVisible: false
  }),
  actions: {
    toggleMenu(this: AppState) {
      this.menuVisible = !this.menuVisible
    },
    setIsMobile(this: AppState, value: boolean) {
      this.isMobile = value
    }
  }
}) 